export enum TaxTypeEnums {
  iva = 1,
  rtf = 2,
  ica = 3,
  reteIva = 4
}